<template>
  <div :class="themeStyleVs === 2 ? 'cl_page black_box' : 'cl_page'">
    <div class="content_main">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="scrollFn"
      >
        <div class="list_main">
          <div class="cl_main" v-for="(item, index) in listData" :key="index">
            <!-- 模拟盘 -->
            <div
              class="mn_content_main"
              v-if="item.type === '3' && item.hq"
              @click.stop="goMnDetail(item)"
            >
              <div class="top">
                <span class="tit">{{ item.hq.ts_name }}</span>
                <!-- 1 策略 2 因子 3 模拟盘 -->
                <div
                  :class="item.hq.isGz ? 'follow_box_show' : 'follow_box'"
                  @click.stop="favorFn('3', item, index)"
                >
                  {{ item.hq.isGz ? '已关注' : '关注' }}
                </div>
              </div>
              <div class="cen_main">
                <ul>
                  <li>
                    <p :class="item.hq.lastProfit.totalRisk | formateRedGreen">
                      {{ toFixedNum(item.hq.lastProfit.totalRisk * 100, 2, '%') }}
                    </p>
                    <p>累计收益</p>
                  </li>
                  <li>
                    <p :class="item.hq.lastProfit.todayRisk | formateRedGreen">
                      {{ toFixedNum(item.hq.lastProfit.todayRisk * 100, 2, '%') }}
                    </p>
                    <p>今日收益</p>
                  </li>
                  <li>
                    <p>{{ toFixedNum(item.hq.lastProfit.maxRetreatRate * 100, 2, '%') }}</p>
                    <p>最大回撤</p>
                  </li>
                </ul>
              </div>

              <div class="chart_box" :id="'chartMn3' + index"></div>
              <div class="food_box clearfix">
                <span class="time_box" v-if="item.hq.lineData.xData.length > 0"
                  >自{{ convertTime(item.hq.lineData.xData[0]) }}</span
                >
                <span class="time_box" v-else>自{{ item.hq.ct.substr(0, 10) }}</span>
                <div class="right_box">
                  <span>收益</span>
                  <span>沪深</span>
                </div>
              </div>
            </div>
            <!-- 策略 -->
            <div
              class="cl_content_main"
              v-if="item.type === '2' && item.hq"
              @click.stop="goClDetail(item)"
            >
              <div class="top">
                <span class="tit">{{ item.hq.s_name }}</span>
                <div
                  :class="item.hq.isGz ? 'follow_box_show' : 'follow_box'"
                  @click.stop="favorFn('2', item, index)"
                >
                  {{ item.hq.isGz ? '已关注' : '关注' }}
                </div>
              </div>
              <div class="intro_box">{{ item.hq.s_desc }}</div>
              <div class="detail_cante">
                <div class="li_box">
                  <div class="lf_box">
                    <p :class="item.hq.RiZhangFu | formateRedGreen">
                      {{ toFixedNum(item.hq.RiZhangFu * 100, 2, '%') }}
                    </p>
                    <p>日涨幅</p>
                  </div>
                  <div class="rg_box">
                    <p>{{ item.hq.XinHaoShuLiang }}只</p>
                    <p>今日信号</p>
                  </div>
                </div>
                <div class="li_box">
                  <div class="lf_box">
                    <p :class="item.hq.BestAvgRate | formateRedGreen">
                      {{ toFixedNum(item.hq.BestAvgRate * 100, 2, '%') }}<span>持股两天</span>
                    </p>
                    <p>最优平均涨幅</p>
                  </div>
                  <div class="rg_box">
                    <p :class="item.hq.MaxRiseRate | formateRedGreen">
                      {{ toFixedNum(item.hq.MaxRiseRate * 100, 2, '%') }}<span>持股一天</span>
                    </p>
                    <p>最大上涨概率</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 因子 -->
            <div
              class="yz_content_main"
              v-if="item.type === '1' && item.hq"
              @click.stop="goDetailYz(item)"
            >
              <div class="tit">
                <span>{{ item.hq.FactorName }}</span>
                <div
                  :class="item.hq.isGz ? 'follow_box_show' : 'follow_box'"
                  @click.stop="favorFn('1', item, index)"
                >
                  {{ item.hq.isGz ? '已关注' : '关注' }}
                </div>
              </div>
              <div class="xifen_box">{{ item.hq.XiFenZhongLei }}</div>
              <div class="chart_main">
                <div class="left">
                  <p :class="item.hq.RiZhangFu | formateRedGreen">
                    {{ toFixedNum(item.hq.RiZhangFu * 100, 2, '%') }}
                  </p>
                  <p>今日涨幅</p>
                </div>
                <div class="right">
                  <div class="chart_box" :id="'chartyz2' + index"></div>
                  <div :class="item.hq.yearsData | bgColor">
                    <p>近一年</p>
                    <p :class="item.hq.yearsData | formateRedGreen">
                      {{ toFixedNum(item.hq.yearsData, 2, '%') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="cen_main">
                <p>
                  <span>今日信号</span><span v-if="item">{{ item.hq.XinHaoShuLiang }}只</span>
                </p>
                <p>
                  <span>涨停</span
                  ><span v-if="item"
                    >{{
                      item.hq.ZhangTingShu || item.hq.ZhangTingShu === 0
                        ? item.hq.ZhangTingShu
                        : '--'
                    }}只</span
                  >
                </p>
                <p>
                  <span>涨逾{{ ZhangYuShu }}%</span
                  ><span v-if="item"
                    >{{
                      item.hq.ZhangYuShu || item.hq.ZhangYuShu === 0 ? item.hq.ZhangYuShu : '--'
                    }}只</span
                  >
                </p>
              </div>
              <div class="long_main">
                <div
                  class="long_li"
                  v-for="(longItem, longIndex) in item.hq.LongTouGu"
                  :key="longIndex"
                >
                  <span>{{ longItem.MingCheng }}</span>
                  <span :class="longItem.ZhangFu | formateRedGreen">{{
                    toFixedNum(longItem.ZhangFu, 2, '%')
                  }}</span>
                </div>
              </div>
              <div class="kd_main">
                <img src="../../assets/image/kd.png" alt="" />
                {{ item.hq.KanDian }}
              </div>
            </div>
            <!-- 财富口令 -->
            <div
              class="cf_content_main"
              v-if="item.type === '4' && item.hq"
              @click.stop="goCfDetail(item)"
            >
              <div class="num_box">#</div>
              <div class="num_box" v-for="(cfitem, cfIndex) in item.ll_id" :key="cfIndex">
                {{ cfitem }}
              </div>
            </div>
          </div>
          <van-empty
            v-if="queryShow && listData.length <= 0"
            class="custom-image"
            :image="not_data"
            description="暂未获取到数据"
          />
        </div>
      </van-list>
    </div>
    <takeOut
      :show="takeShow"
      :name="takeName"
      :btnText="takeBtnName"
      :type="takeLinkType"
      @cancelBasis="cancelBasis"
      @linkGo="linkGo"
    ></takeOut>
  </div>
</template>

<script>
import mixins from '@/mixins/index.js';
import { getMyBrowse, getFactorTrend } from '@/api/my.js';
import { getFactorHq, addMyFavor, delMyFavor, getClientRedis } from '@/api/index.js';
import { newFangDouFun,compareVersions } from '@/utils/format.js';
import takeOut from '@/components/notHd/TakeOut.vue';
export default {
  name: 'Yl',
  mixins: [mixins],
  components: {
    takeOut
  },
  data() {
    return {
      ZhangYuShu: window.config.ZhangYuShu,
      hotTacticInterval: null, // 行情中定时器 因子
      clTacticInterval: null, //策略行情
      total: 0,
      page: 0,
      pageSize: 20,
      allData: [],
      listData: [],
      chartList: [],
      queryShow: false,
      not_data: require('../../assets/image/notData.png'),
      themeStyleVs: 1,
      scrollQuery: false,
      loading: false,
      finished: false,
      finishedText: '没有更多了',
      takeShow: false,
      takeName: '',
      takeBtnName: '',
      takeLinkType: '',
      linkData: ''
    };
  },
  filters: {
    bgColor: function (num) {
      if (num > 0) {
        return 'one_year_box red_bg';
      } else if (num < 0) {
        return 'one_year_box green_bg';
      }
    }
  },
  created() {
    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
  },
  mounted() {
    this.loading = true;
    this.getData();
    this.$toast.loading({
      message: '加载中...',
      overlay: true,
      duration: 0
    });
  },
  methods: {
    compareVersions,
    getData: function () {
      let that = this;
      getMyBrowse({})
        .then((res) => {
          that.$toast.clear();
          if (res.err === 200) {
            that.allData = res.data;
            that.listData = res.data.slice(0, 20);
            that.$nextTick(function () {
              that.checkData(res.data.slice(0, 20));
            });
          } else {
            that.finished = true;
            that.loading = true;
            that.finishedText = '';
            that.queryShow = true;
          }
        })
        .catch(() => {
          that.finished = true;
          that.loading = true;
          that.finishedText = '';
          that.queryShow = true;
          that.$toast.clear();
        });
    },
    scrollFn: function () {
      let that = this;
      that.loading = true;
      that.listData = [
        ...that.listData,
        ...that.allData.slice(that.listData.length, that.listData.length + that.pageSize)
      ];
      that.$nextTick(function () {
        that.checkData(
          that.allData.slice(that.page * that.pageSize, that.page * that.pageSize + that.pageSize)
        );
      });
    },
    // 处理数据 判断类型 请求其他数据
    checkData: function (data) {
      let that = this;
      that.scrollQuery = true;
      let listData = data;
      let yzData = listData.filter((item) => {
        if (item.type === '1') return item;
      });
      that.getYzzs(yzData);
      that.getClHq();
      // that.clTacticInterval = window.setInterval(() => {
      //   that.getClHq();
      // }, 60000);

      that.chartFn();
      that.$nextTick(function () {
        that.scrollQuery = false;
        if (data.length < 10) {
          //是否已加载完成，加载完成后不再触发load事件
          that.finished = true;
        } else {
          that.loading = false;
          that.page += 1;
          that.finished = false;
        }
      });
    },
    // 获取多因子走势
    getYzzs: function (data) {
      let that = this;
      let factors = data.map((item) => {
        return item.ll_id;
      });
      factors = factors.toString().replaceAll(',', '_');
      // if(!factors) return;
      getFactorTrend({ factors: factors }).then((res) => {
        if (res.err === 200) {
          let keys = Object.keys(res.data);

          keys.forEach((item) => {
            that.listData.forEach((dataItem, index) => {
              if (item === dataItem.ll_id) {
                if (that.listData[index].hq) {
                  that.$set(that.listData[index].hq, 'chartX', res.data[item].xAxis);
                  that.$set(that.listData[index].hq, 'chartY', res.data[item].yAxis);
                  that.$set(that.listData[index].hq, 'yearsData', res.data[item].yearsData);
                } else {
                  that.$set(that.listData[index], 'hq', null);
                }
              }
            });
          });
          that.$nextTick(function () {
            that.chartFnyz();
            that.getHqYz();
            // that.hotTacticInterval = window.setInterval(() => {
            //   that.getHqYz();
            // }, 60000);
          });
        } else {
        }
      });
    },
    chartFnyz: function () {
      let that = this;
      let chartData = that.listData;
      chartData.forEach((item, index) => {
        if (item.type !== '1' || !item.hq) return;
        if (!that.chartList[index]) {
          let chartDom = document.getElementById('chartyz2' + index);
          that.chartList[index] = that.$echarts.init(chartDom);
          window.addEventListener('resize', that.resizeHandler);
        }
        let xData = item.hq.chartX;
        let dataY = item.hq.chartY;
        let markLineData = item.hq.chartY.length > 0 ? item.hq.chartY[0] : 0;
        let color = item.hq.yearsData > 0 ? ['#EF3939'] : ['#1EAC4E'];
        let option = {
          color: color,
          grid: {
            left: 0,
            top: 5,
            right: 0,
            bottom: 5
          },
          xAxis: {
            show: false,
            type: 'category',
            data: xData
          },
          yAxis: {
            show: false,
            type: 'value',
            min: function (minData) {
              return minData.min;
            },
            max: function (maxData) {
              return maxData.max;
            }
          },
          series: [
            {
              symbol: 'none',
              data: dataY,
              type: 'line',
              smooth: true,
              itemStyle: {
                lineStyle: {
                  color: '#000000' //改变折线颜色
                }
              },
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color:
                        item.hq.yearsData > 0 ? 'rgba(239, 57, 57, .5)' : 'rgba(30, 172, 78, .5)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: item.hq.yearsData > 0 ? 'rgba(239, 57, 57, 0)' : 'rgba(30, 172, 78, 0)' // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markLine: {
                symbol: ['none', 'none'], // none为标线两端的样式为无，可更改
                data: [
                  {
                    silent: false,
                    yAxis: markLineData, // 表现自定义的位置，可赋值
                    label: {
                      position: 'end', // 表现内容展示的位置
                      formatter: '中文路均值', // 标线展示的内容
                      color: '#8C8C8C', // 展示内容颜色
                      show: false
                    },
                    lineStyle: {
                      type: 'dashed',
                      color: 'rgba(153, 153, 153, 1)',
                      width: 1
                    }, // 样式： 线型、颜色、线宽
                    emphasis: {
                      lineStyle: {
                        width: 1 // hover时的折线宽度
                      }
                    }
                  }
                ]
              }
            }
          ]
        };
        option && that.chartList[index].setOption(option);
      });
    },
    resizeHandler() {
      this.chartList.forEach((item) => {
        if (item) {
          item.resize();
        }
      });
    },
    getHqYz: function () {
      let that = this;
      let idKeys = that.listData.filter((item) => {
        return item.type === '1' && item.hq;
      });
      idKeys = idKeys.map((item) => {
        return item.hq.ID;
      });
      idKeys = idKeys.toString().replaceAll(',', '_');
      let obj = {
        type: 'yz',
        factorID: idKeys.replaceAll('_', ','),
        field: 'Desc,LongTouGu,KanDian,FactorCode,zhangdietongji,XiFenZhongLei'
      };
      getFactorHq(obj).then((res) => {
        if (res.err === 200) {
          let data = that.listData;
          res.data.forEach((item) => {
            data.forEach((dataItem, index) => {
              if (dataItem.hq) {
                if (item.ID === dataItem.hq.ID) {
                  that.$set(that.listData[index].hq, 'Desc', item.Desc);
                  that.$set(that.listData[index].hq, 'FactorName', item.FactorName);
                  if (item.LongTouGu) {
                    that.$set(that.listData[index].hq, 'LongTouGu', item.LongTouGu.slice(0, 2));
                  }
                  that.$set(that.listData[index].hq, 'RiZhangFu', item.RiZhangFu);
                  that.$set(that.listData[index].hq, 'XinHaoShuLiang', item.XinHaoShuLiang);
                  if (item.ZhangDieTongJi) {
                    that.$set(that.listData[index].hq, 'ZhangTingShu', item.ZhangDieTongJi[0]);
                    that.$set(that.listData[index].hq, 'ZhangYuShu', item.ZhangDieTongJi[7]);
                  }
                  that.$set(that.listData[index].hq, 'KanDian', item.KanDian);
                  that.$set(that.listData[index].hq, 'FactorCode', item.FactorCode);
                  that.$set(that.listData[index].hq, 'XiFenZhongLei', item.XiFenZhongLei);
                }
              }
            });
          });
        }
      });
    },
    // 获取策略中行情
    getClHq: function () {
      let that = this;
      let idKeys = that.listData.filter((item) => {
        return item.type === '2';
      });
      idKeys = idKeys.map((item) => {
        return item.hq.f_id_arr.replaceAll(',', '_');
      });
      idKeys = idKeys.toString();
      let obj = {
        type: 'cl',
        groupID: idKeys,
        field: 'Desc'
      };
      getFactorHq(obj).then((res) => {
        if (res.err === 200) {
          res.data.forEach((item) => {
            that.listData.forEach((allItem, index) => {
              if (allItem.hq) {
                if (item.ID.replaceAll('_', ',') === allItem.hq.f_id_arr) {
                  that.$set(that.listData[index].hq, 'RiZhangFu', item.RiZhangFu);
                  that.$set(that.listData[index].hq, 'XinHaoShuLiang', item.XinHaoShuLiang);
                }
              }
            });
          });
        }
      });
    },
    // 创建图表
    chartFn: function () {
      let that = this;
      let dataList = that.listData;
      dataList.forEach((item, index) => {
        if (item.type === '3' && item.hq) {
          if (!that.chartList[index]) {
            let chartDom = document.getElementById('chartMn3' + index);
            that.chartList[index] = that.$echarts.init(chartDom);
            window.addEventListener('resize', that.resizeHandler);
          }
          let xData = item.hq.lineData.xData;
          let dataSy = item.hq.lineData.profitRate;
          let dataHs = item.hq.lineData.hs300Rate;
          let option = {
            color: ['#286DF7', '#FF770C'],
            grid: {
              left: 0,
              top: 0,
              right: 0,
              bottom: 0
            },
            xAxis: {
              show: false,
              type: 'category',
              data: xData
            },
            yAxis: {
              show: false,
              type: 'value'
            },
            series: [
              {
                symbol: 'none',
                data: dataSy,
                type: 'line',
                smooth: true,
                itemStyle: {
                  lineStyle: {
                    color: '#000000' //改变折线颜色
                  }
                }
              },
              {
                symbol: 'none',
                data: dataHs,
                type: 'line',
                smooth: true,
                itemStyle: {
                  lineStyle: {
                    color: '#FF770C' //改变折线颜色
                  }
                },
                markLine: {
                  symbol: ['none', 'none'], // none为标线两端的样式为无，可更改
                  data: [
                    {
                      silent: false,
                      yAxis: 0, // 表现自定义的位置，可赋值
                      label: {
                        position: 'end', // 表现内容展示的位置
                        formatter: '中文路均值', // 标线展示的内容
                        color: '#8C8C8C', // 展示内容颜色
                        show: false
                      },
                      lineStyle: {
                        type: 'dashed',
                        color: that.themeStyleVs === 2 ? '#6b7687' : 'rgba(0, 0, 0, 0.2)',
                        width: 1
                      } // 样式： 线型、颜色、线宽
                    }
                  ]
                }
              }
            ]
          };
          option && that.chartList[index].setOption(option);
        }
      });
    },
    // 点击关注、已关注按钮
    favorFn: function (type, item, index) {
      if (item.hq.isGz) {
        this.delFavorFn(type, item, index);
      } else {
        this.addFavorFn(type, item, index);
      }
    },
    // 加入关注
    // 1 策略 2 因子 3 模拟盘
    // "2", //类型2-策略  "1",  // 类型1-因子 3 模拟盘
    addFavorFn: function (type, item, index) {
      let that = this;
      let obj;
      if (type === '1') {
        obj = {
          type: '2',
          id: item.hq.ID,
          s_name: item.hq.FactorName,
          f_id_arr: item.hq.ID,
          creator: ''
        };
      } else if (type === '2') {
        obj = {
          type: '1',
          id: item.hq.s_id,
          s_name: item.hq.s_name,
          f_id_arr: item.hq.f_id_arr,
          creator: ''
        };
      } else if (type === '3') {
        obj = {
          type: type,
          id: item.hq.zj_id,
          s_name: item.hq.ts_name,
          f_id_arr: item.hq.zj_id,
          creator: '',
          counter_num: item.counter_num
        };
      }
      addMyFavor(obj).then((res) => {
        if (res.err === 200) {
          that.$set(that.listData[index].hq, 'isGz', true);
          that.$toast('关注成功');
          if (type === '1') {
            if (typeof DzhAppJs != 'undefined') {
              DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                'updateFactorFollowStatus',
                JSON.stringify({ factorId: data.s_id, followStatus: 1 }),
                ''
              );
            }
          }
        }
      });
    },
    // 取消关注
    delFavorFn: function (type, item, index) {
      let that = this;
      let obj;
      if (type === '1') {
        obj = {
          type: '2',
          id: item.hq.ID
        };
      } else if (type === '2') {
        obj = {
          type: '1',
          id: item.hq.s_id
        };
      } else if (type === '3') {
        obj = {
          type: type,
          id: item.hq.zj_id
        };
      }
      delMyFavor(obj).then((res) => {
        if (res.err === 200) {
          that.$set(that.listData[index].hq, 'isGz', false);
          that.$toast('取消关注成功');
          if (type === '1') {
            if (typeof DzhAppJs != 'undefined') {
              DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                'updateFactorFollowStatus',
                JSON.stringify({ factorId: data.s_id, followStatus: 0 }),
                ''
              );
            }
          }
        }
      });
    },
    goMnDetail: function (item) {
      let that = this;
      that.takeLinkType = 'mn';
      that.linkData = item;
      // if (localStorage.getItem('mn') === 'true') {
      that.gotoUrlInfo('/mnDetail', 'mnDetail', {
        zj_id: item.hq.zj_id,
        sourceType: true,
        themeStyleVs: that.themeStyleVs,
        type: 'hot'
      });
      // } else {
      //   that.takeName =
      //     '每次查看热门模拟交易(包括关注和最近浏览)需消耗 8个慧豆，且今日内查看相同策略不会重复扣豆';
      //   that.takeBtnName = '继续查看';
      //   that.takeShow = true;
      // }
    },
    goClDetail: function (item) {
      let that = this;
      that.takeLinkType = 'cl';
      that.linkData = item;
      // if (localStorage.getItem('cl') === 'true') {
      this.gotoUrlInfo('/clDetail', 'clDetail', {
        s_id: item.hq.s_id,
        sourceType: true,
        themeStyleVs: that.themeStyleVs,
        type: 'hot'
      });
      // } else {
      //   that.takeName =
      //     '每次查看热门策略(包括关注和最近浏览)需消耗 5个慧豆，且今日内查看相同策略不会重复扣豆';
      //   that.takeBtnName = '继续查看';
      //   that.takeShow = true;
      // }
    },
    cancelBasis: function (e) {
      this.takeShow = e;
    },
    linkGo: function () {
      let that = this;
      let type = that.takeLinkType;
      let item = that.linkData;
      if (type === 'cl') {
        that.$store.commit('setSmallTab', that.typeId);
        this.gotoUrlInfo('/clDetail', 'clDetail', {
          s_id: item.hq.s_id,
          sourceType: true,
          themeStyleVs: that.themeStyleVs,
          type: 'hot'
        });
      } else {
        that.$store.commit('setSmallTab', that.typeId);
        that.gotoUrlInfo('/mnDetail', 'mnDetail', {
          zj_id: item.hq.zj_id,
          sourceType: true,
          themeStyleVs: that.themeStyleVs,
          type: 'hot'
        });
      }
      this.cancelBasis(false);
    },
    goDetailYz: function (item) {
      let that = this;
      if ( !compareVersions(that.getUrlQuery('version') ,  9.66)  && window.config.editionText !== '') {
        that.$emit('diagShow', true);
        return;
      }
      if (typeof DzhAppJs == 'undefined') {
        console.log('请在大智慧中打开');
      } else {
        // 因子详情页 factorid 因子id，factorname 因子名称，factorcode 因子代码
        window.location.href =
          'dzh_browser_url&goto=0&screen=464&factorid=' +
          item.hq.ID +
          '&factorname=' +
          item.hq.FactorName +
          '&factorcode=' +
          item.hq.FactorCode;
      }
    },
    goCfDetail: function (item) {
      if ( !compareVersions(this.getUrlQuery('version'),9.66) && window.config.editionText !== '') {
        this.$emit('diagShow', true);
        return;
      }
      window.location.href = `dzh_browser_url&goto=0&screen=464&treasureid=${item.ll_id}`;
    }
  },
  beforeDestroy() {
    let that = this;
    window.clearInterval(that.clTacticInterval);
    that.clTacticInterval = null;
    // window.clearInterval(that.hotTacticInterval);
    // that.hotTacticInterval = null;
    that.chartList.forEach((item) => {
      if (item) {
        item.dispose();
      }
    });
    that.chartList = [];
    window.removeEventListener('resize', this.resizeHandler);
  }
};
</script>
<style lang="less" scoped>
.cl_page {
  width: 100%;
  height: 100%;
  .content_main {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .list_main {
      width: 100%;
      height: 100%;
    }
    padding: 12px 12px;
    .cl_main {
      .follow_box {
        padding: 4px 12px;
        border-radius: 4px;
        background: rgba(40, 109, 247, 0.1);
        color: #286df7;
      }
      .follow_box_show {
        padding: 4px 12px;
        border-radius: 4px;
        background: rgba(153, 153, 153, 0.0588235);
        color: #999999;
      }
      .mn_content_main {
        width: 100%;
        background-color: #fff;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 15px 12px;
        box-sizing: border-box;
        margin-bottom: 8px;
        position: relative;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          .tit {
            font-size: 16px;
            color: #373a4d;
            font-weight: 500;
          }
        }
      }
      .cl_content_main {
        width: 100%;
        background-color: #fff;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 15px 12px;
        box-sizing: border-box;
        margin-bottom: 8px;
        position: relative;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          .tit {
            font-size: 16px;
            color: #373a4d;
            font-weight: 500;
          }
          img {
            display: inline-block;
            width: 24px;
            height: 24px;
          }
        }
        .intro_box {
          font-size: 12px;
          line-height: 16px;
          color: #666666;
          margin-bottom: 8px;
        }
        .detail_cante {
          width: 100%;
          .li_box {
            margin-bottom: 4px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:last-child {
              margin-bottom: 0;
            }
            div {
              width: 158px;
              padding: 9px 0;
              box-sizing: border-box;
              background: #f9f9f9;
              border-radius: 4px;
              text-align: center;
              p {
                span {
                  font-size: 10px;
                  color: #666666;
                  margin-left: 4px;
                }
                &:first-child {
                  font-weight: 500;
                  font-size: 16px;
                  color: #373a4d;
                }
                &:last-child {
                  font-size: 12px;
                  color: #999999;
                  line-height: 14px;
                }
              }
            }
          }
        }
      }
      .yz_content_main {
        display: inline-block;
        width: 100%;
        padding: 12px 16px;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 8px;
        margin-bottom: 8px;
        position: relative;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .top_img {
          position: absolute;
          top: 0;
          left: 0;
          width: 10px;
          height: 10px;
        }
        .tit {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 4px;
          span {
            font-size: 16px;
            font-weight: 600;
            color: #222;
          }
          img {
            display: inline-block;
            width: 24px;
            height: 24px;
          }
        }
        .xifen_box {
          display: inline-block;
          padding: 4px 8px;
          background: rgba(254, 116, 0, 0.1);
          border-radius: 4px;
          font-size: 12px;
          color: #fe7400;
          margin: 7px 0 6px 0;
        }
        .chart_main {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          .left {
            p {
              &:first-child {
                color: #222;
                font-size: 20px;
                font-weight: 500;
              }
              &:last-child {
                font-size: 12px;
                color: #999;
              }
            }
          }
          .right {
            display: flex;
            align-items: center;
            .chart_box {
              width: 155px;
              height: 48px;
              margin-right: 8px;
            }
            .one_year_box {
              background: #f7f8fa;
              padding: 2px 6px;
              border-radius: 8px 8px 8px 0px;
              &.red_bg {
                background-color: rgba(239, 57, 57, 0.1);
              }
              &.green_bg {
                background-color: rgba(30, 172, 78, 0.1);
              }
              p {
                font-size: 10px;
                color: #555;
              }
            }
          }
        }
        .cen_main {
          width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 4px;
          p {
            text-align: center;
            flex: 1;
            position: relative;
            &::after {
              content: ' ';
              position: absolute;
              width: 1px;
              height: 6px;
              background-color: #e5e5e5;
              right: 0;
              top: 50%;
              transform: translate(-50%, 0);
            }
            &:last-child {
              &::after {
                content: none;
              }
            }
            span {
              &:first-child {
                font-size: 12px;
                color: #999;
                margin-right: 4px;
              }
              &:last-child {
                font-size: 12px;
                color: #555;
              }
            }
          }
        }
        .long_main {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: row;
          flex-wrap: wrap;
          .long_li {
            width: 153px;
            height: 22px;
            background-color: #f7f8fa;
            border-radius: 4px;
            margin-bottom: 4px;
            padding: 0 12px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            span {
              font-size: 12px;
              color: #555;
              &:first-child {
                margin-right: 6px;
              }
            }
          }
        }
        .kd_main {
          padding-left: 6px;
          font-size: 12px;
          color: #555;
          img {
            width: 27px;
            height: 11px;
            margin-right: 4px;
            display: inline-block;
          }
        }
      }
      .cf_content_main {
        display: inline-block;
        width: 100%;
        padding: 12px 16px;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 8px;
        margin-bottom: 8px;
        position: relative;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        display: flex;
        align-items: center;
        .num_box {
          width: 24px;
          font-size: 18px;
          color: #222;
          background-color: #f7f8fa;
          border-radius: 4px;
          margin-right: 4px;
          text-align: center;
          &:last-child {
            margin: 0;
          }
        }
      }
    }
    .list_main {
      height: 100%;
      width: 100%;
      .main {
        margin-bottom: 8px;
      }
      .cen_main {
        width: 100%;
        margin-bottom: 4px;
        ul {
          width: 100%;
          display: flex;
          li {
            width: 106px;
            height: 52px;
            background: #f9f9f9;
            border-radius: 4px;
            margin-right: 4px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            &:last-child {
              margin-right: 0;
            }
            p {
              &:first-child {
                font-size: 16px;
                // color: #EF3939;
                font-weight: 500;
              }
              &:last-child {
                font-size: 12px;
                color: #999999;
              }
            }
          }
        }
      }
      .chart_box {
        width: 326px;
        height: 52px;
        // background-color: #f8f8f8;
        margin-bottom: 2px;
      }
      .food_box {
        width: 100%;
        padding-left: 8px;
        font-size: 12px;
        color: #999999;
        line-height: 14px;
        .time_box {
          float: left;
        }
        .right_box {
          float: right;
          span {
            position: relative;
            &:first-child {
              margin-right: 17px;
              position: relative;
              &::before {
                background-color: #286df7;
              }
            }
            &:last-child {
              &::before {
                background-color: #ff770c;
              }
            }
            &::before {
              content: '';
              width: 4px;
              height: 4px;
              border-radius: 50%;
              position: absolute;
              top: 7px;
              left: -8px;
            }
          }
        }
      }
    }
  }
}
.black_box {
  .content_main {
    .cl_main {
      .cl_content_main {
        background-color: #181a23;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .top {
          .tit {
            color: #e4e9fe;
          }
          .follow_box {
            background-color: rgba(40, 109, 247, 0.1);
            color: #286df7;
          }
        }
        .intro_box {
          color: #aab9d1;
        }
        .detail_cante {
          .li_box {
            div {
              background-color: #1d202d;
              p {
                &:first-child {
                  color: #e4e9fe;
                  span {
                    color: #666666;
                  }
                }
                &:last-child {
                  color: #6b7687;
                }
              }
            }
          }
        }
      }
      .mn_content_main {
        background-color: #181a23;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .top {
          .tit {
            color: #e4e9fe;
          }
          .follow_box {
            background-color: rgba(40, 109, 247, 0.1);
            color: #286df7;
          }
        }
        .cen_main {
          ul {
            li {
              background-color: #1d202d;
              p {
                &:first-child {
                  color: #e4e9fe;
                }
                &:last-child {
                  color: #6b7687;
                }
              }
            }
          }
        }
        .chart_box {
          background-color: #1d202d;
        }
        .food_box {
          .time_box {
            color: #6b7687;
          }
          .right_box {
            span {
              color: #6b7687;
            }
          }
        }
      }
      .yz_content_main {
        background-color: #181a23;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .tit {
          span {
            color: #e4e9fe;
          }
          .follow_box {
            background-color: rgba(40, 109, 247, 0.1);
            color: #286df7;
          }
        }
        .xifen_box {
          background: rgba(254, 116, 0, 0.2);
        }
        .chart_main {
          .left {
            p {
              &:last-child {
                color: #6b7687;
              }
              &:first-child {
                color: #6b7687;
              }
            }
          }
          .right {
            .chart_box {
              background-color: #181a23;
            }
            .one_year_box {
              p {
                color: #aab9d1;
              }
            }
          }
        }
        .cen_main {
          p {
            &::after {
              background-color: rgba(255, 255, 255, 0.1);
            }
            span {
              &:first-child {
                color: #6b7687;
              }
              &:last-child {
                color: #aab9d1;
              }
            }
          }
        }
        .long_main {
          .long_li {
            background-color: #1d202d;
            span {
              color: #aab9d1;
            }
          }
        }
        .kd_main {
          color: #aab9d1;
        }
      }
      .cf_content_main {
        background-color: #181a23;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .num_box {
          background-color: #1d202d;
          color: #e4e9fe;
        }
      }
    }
  }
}
</style>
<style></style>
